<template>
  <!-- :selection="selection" -->

  <div>
    <vi-table
      :header="header"
      :columns="columns"
      :action="action"
      :paging="paging"
      :data="data"
      :body-header-show="bodyHeaderShowValue"
      :loading="loading"
      :select-enable="selectEnable"
      :select-items.sync="selectValue"
      v-model="checked"
      @e-header-action="eHeaderAction"
      @e-row-action="eRowAction"
      @e-paging-index="ePagingIndex"
      @e-link-click="eLinkClick"
    >
      <template v-for="col in columns" v-slot:[`table_col_${col.name}`]="scope">
        <slot
          :name="`table_col_${col.name}`"
          v-bind:field="scope.field"
          v-bind:row="scope.row"
        ></slot>
      </template>
      <template v-slot:header-init>
        <slot name="header-init"></slot>
      </template>
      <template #header-search>
        <DatatableSearch v-model="keyword" :search="search">
          <template #append>
            <slot name="search-append"></slot>
          </template>
        </DatatableSearch>
      </template>
      <template v-slot:header-bottom>
        <slot name="header-bottom"></slot>
      </template>

      <template v-slot:body-header>
        <slot name="body-header">
          <vi-breadcrumb
            v-if="breadcrumbable"
            v-model="breadcrumbs"
            @e-item-click="eBreadcrumbItemClick"
          >
          </vi-breadcrumb>
        </slot>
      </template>

      <template v-slot:footer-left>
        <slot name="footer-left"></slot>
      </template>
    </vi-table>
    <vi-modal
      v-if="addable"
      v-model="showAdd"
      :title="addModelTitle"
      size="lg"
      @e-cancel="addCancel"
      @e-confirm="addConfirm"
    >
      <vi-form ref="addForm" :fields="add.fields" v-model="addArgs">
        <template
          v-for="field in add.fields"
          v-slot:[addSlotName(field)]="scope"
        >
          <slot
            :name="'add_field_' + scope.field.name"
            v-bind:field="scope.field"
            v-bind:on-changed="scope.onChanged"
          >
          </slot>
        </template>
      </vi-form>
    </vi-modal>
    <vi-modal
      v-if="editable"
      v-model="showEdit"
      :title="editModelTitle"
      size="lg"
      @e-confirm="editConfirm"
    >
      <vi-form ref="editForm" :fields="edit.fields" v-model="editArgs">
        <template
          v-for="field in edit.fields"
          v-slot:[addSlotName(field)]="scope"
        >
          <slot
            :name="'edit_field_' + scope.field.name"
            v-bind:field="scope.field"
            v-bind:on-changed="scope.onChanged"
          >
          </slot>
        </template>
      </vi-form>
    </vi-modal>
  </div>
</template>

<script>
import DatatableSearch from "./DatatableSearch.vue";
export default {
  name: "DataTable",
  components: {
    DatatableSearch,
  },
  data() {
    return {
      keyword: null,

      loading: false,
      checked: [],
      selection: {
        enable: false,
      },
      paging: {
        enable: true,
        index: 1,
        size: 10,
        count: 1,
        total: 0,
      },
      data: [],
      showAdd: false,
      addArgs: {},
      showEdit: false,
      editItem: {},
      editArgs: {},
      columns: [],
      breadcrumbs: [],
    };
  },
  watch: {
    params() {
      this.reload();
    },
    keyword(val) {
      if (val && val.length < 2) {
        return;
      }

      this.$emit("update:antistop", val);
      this.reload();
    },
  },
  computed: {
    header() {
      let actionItems = [];
      if (this.addable) {
        let label = this.add.label;
        if (!label) {
          label = this.label ? `添加新${this.label}` : "添加";
        }
        actionItems.push({
          name: "add",
          color: "primary",
          icon: "fas:plus",
          label: label,
        });
      }
      let tit = this.title;
      if (this.title) {
        tit = this.title;
      } else {
        tit = this.label ? ` ${this.label}` : "";
      }
      return {
        title: tit,
        action: {
          items: actionItems,
        },
      };
    },
    action() {
      let actionItems = [];
      if(this.svgtable){
        let temp = {
          name: "svg",
          icon: "",
          tips: "编辑",
          svg:true
        };
        if (
          this.svg.onSetDisabled &&
          typeof this.svg.onSetDisabled === "function"
        ) {
          temp["onSetDisabled"] = this.svg.onSetDisabled;
        }
        actionItems.push(temp);
      }
      if (this.editable) {
        let temp = {
          name: "edit",
          icon: "fas:edit",
          tips: "编辑",
        };
        if (
          this.edit.onSetDisabled &&
          typeof this.edit.onSetDisabled === "function"
        ) {
          temp["onSetDisabled"] = this.edit.onSetDisabled;
        }
        actionItems.push(temp);
      }
      if (this.removeable) {
        let temp = {
          name: "trash",
          icon: "fas:trash",
          tips: "删除",
        };

        if (
          this.remove.onSetDisabled &&
          typeof this.remove.onSetDisabled === "function"
        ) {
          temp["onSetDisabled"] = this.edit.onSetDisabled;
        }
        actionItems.push(temp);
      }
      if (this.rowActions) {
        this.rowActions.map((item) => actionItems.push(item));
      }
      return {
        enable: actionItems.length > 0,
        items: actionItems,
      };
    },
    addable() {
      if (this.add) {
        return this.add.enable;
      } else {
        return false;
      }
    },
    editable() {
      if (this.edit) {
        return this.edit.enable;
      } else {
        return false;
      }
    },
    svgtable() {
      if (this.svg) {
        return this.svg.enable;
      } else {
        return false;
      }
    },
    removeable() {
      if (this.remove) {
        return this.remove.enable;
      } else {
        return false;
      }
    },
    breadcrumbable() {
      if (this.breadcrumb) {
        return this.breadcrumb.enable;
      } else {
        return false;
      }
    },
    addModelTitle() {
      let label = "";
      if (this.add) {
        label = this.add.label;
      }
      if (!label) {
        label = `添加新${this.label}`;
      }
      return label;
    },
    editModelTitle() {
      let label = "";
      if (this.edit) {
        label = this.edit.label;
      }
      if (!label) {
        label = `编辑[${this.editItem.name}]`;
      }
      return label;
    },
    bodyHeaderShowValue() {
      if (this.breadcrumbable) {
        if (this.breadcrumbs.length > 0) {
          return true;
        }
        return false;
      }
      return this.bodyHeaderShow;
    },
    selectValue: {
      get() {
        return this.selectItems;
      },
      set(val) {
        this.$emit("update:selectItems", val);
      },
    },
  },
  mounted() {
    this.fieldsInit();

    if (this.paramsFromRouter) {
      let params = this.$$.navigate.currentParams();
      for (let n in this.params) {
        if (params[n]) {
          this.$set(this.params, n, params[n]);
        }
      }
    }

    if (this.mountedLoad) {
      this.reload();
    }
  },
  methods: {
    addSlotName(field) {
      return "field_" + field.name;
    },
    eHeaderAction(action) {
      if (action.name === "add") {
        if (this.add.type && this.add.type === "page") {
          this.$$.navigate.to({
            label: `${this.add.page.label}`,
            path: `${this.add.page.url}`,
          });
        } else {
          if (this.addable) {
            this.showAdd = true;
          }
        }
      }
    },
    addCancel() {
      this.$refs.addForm.reset();
    },
    addConfirm() {
      let valid = this.$refs.addForm.validation();
      if (!valid) {
        return;
      }

      if (this.addArgs.mobile && this.addArgs.mobile.indexOf("+86-") <= -1) {
        this.addArgs.mobile = `+86-${this.addArgs.mobile}`;
      }
      let item = { ...this.params, ...this.addArgs };
      let req;

      this.$emit("e-pre-add", item);

      if (this.add && this.add.url) {
        req = this.$$.api.post(this.add.url, item);
      } else {
        req = this.$$.api.data.add(this.url, { item: item });
      }

      req
        .then(() => {
          let label = this.label;
          let success = this.add.success;

          if (!success) {
            success = function (r) {
              return `成功添加[${r.name}]${label}`;
            };
          }
          this.$$.toastr.success(success(item));
          this.showAdd = false;
          this.$refs.addForm.reset();
          this.reload();
        })
        .catch((error) => {
          this.$$.toastr.error(error.message);
        });
    },
    editConfirm() {
      console.log(this.$refs.editForm);

      let valid = this.$refs.editForm.validation();
      if (!valid) {
        this.$$.toastr.error("提交验证不通过，请检查字段的值是否正确。");
        return;
      }

      let modify = {};
      for (let n in this.editArgs) {
        if (this.editArgs[n] !== this.editItem[n]) {
          modify[n] = this.editArgs[n];
        }
      }
      if (modify.mobile && modify.mobile.indexOf("+86-") <= -1) {
        modify.mobile = `+86-${modify.mobile}`;
      }
      this.$emit("e-pre-edit", modify);

      let name = this.$refs.editForm.originalValue.name || "";

      this.$$.api.data
        .modify(this.url, {
          sn: this.editItem.sn,
          item: modify,
        })
        .then(() => {
          let label = this.label;
          let success = this.edit.success;

          if (!success) {
            success = function (r) {
              return `成功保存[${r.name ? r.name : name}]${label}`;
            };
          }
          this.$$.toastr.success(success(this.editArgs));
          this.showEdit = false;
          this.reload();
        })
        .catch((error) => {
          this.$$.toastr.error(error.message);
        });
    },
    eRowAction(action, row) {
      if (action.name === "trash") {
        let confirm = this.remove.confirm;
        let label = this.label;
        if (!confirm) {
          confirm = function (r) {
            return `是否真的要删除[${r.name}]${label}`;
          };
        }
        let success = this.remove.success;
        if (!success) {
          success = function (r) {
            return `成功删除[${r.name}]${label}`;
          };
        }
        this.$$.swal.confirm(confirm(row)).then((result) => {
          if (result.isConfirmed) {
            this.$$.api.data
              .remove(this.url, { sn: row.sn })
              .then(() => {
                this.$$.toastr.success(success(row));
                this.reload();
              })
              .catch((error) => {
                this.$$.toastr.error(error.message);
              });
          }
        });
      } else if (action.name === "edit") {
        this.editItem = row;
        if (this.edit.type && this.edit.type === "page") {
          if (
            !this.edit.page ||
            !this.edit.page.onBegin ||
            !typeof this.edit.page.onBegin === "function"
          ) {
            this.$$.toastr.error("未配置页面");
            return;
          }

          let begin = this.edit.page.onBegin(row, action);
          this.$$.navigate.to({
            label: begin.label,
            path: begin.url,
          });
        } else {
          this.$refs.editForm.reset(row);
          this.edit.fields.map((p) => {
            if (p.type == "mobile") {
              p.value = p.value.slice(p.value.indexOf("-") + 1);
            }
          });
          this.showEdit = true;
        }
      } else {
        this.$emit("e-row-action", action, row);
      }
    },
    ePagingIndex() {
      this.reload();
    },
    reload() {
      this.selectValue = [];
      
      this.loading = true;
      let requirement = {
        filters: [],
      };

      requirement;

      if (this.orderBy) {
        requirement["orderBy"] = this.orderBy.name ? this.orderBy.name : "";
        requirement["OrderByType"] = this.orderBy.type
          ? this.orderBy.type
          : "Asc";
      }
      // 解析查询参数
      if (this.params) {
        if (this.params instanceof Array && this.params.length >= 1) {
          for (let item of this.params) {
            if (typeof item === "string") {
              let n = item.split(" ");
              if (n.length !== 3) {
                this.$$.toastr.error(`[${item}]搜索参数定义不正确`);
                break;
              }
              requirement.filters.push({
                name: n[0],
                type: n[1],
                value: n[2],
              });
            } else if (item instanceof Object) {
              requirement.filters.push(item);
            }
          }
        } else {
          for (let n in this.params) {
            if (this.params[n]) {
              requirement.filters.push({
                name: n,
                type: "Equal",
                value: this.params[n],
              });
            }
          }
        }
      }

      if (this.keyword && this.keyword.length > 1) {
        requirement["keyword"] = this.keyword;
      }

      let columns = [];
      this.fields.map((field) => {
        let source = field.source;
        if (!source) {
          source = field.name;
        }
        columns.push(source);
      });

      this.$$.api.data
        .page(this.url, {
          pageIndex: this.paging.index,
          pageSize: this.paging.size,
          requirement: requirement,
          columns: columns,
        })
        .then((result) => {
          this.data = result.data.page.items;
          this.paging.index = result.data.page.pageIndex;
          this.paging.size = result.data.page.pageSize;
          this.paging.total = result.data.page.total;
          this.paging.count = result.data.page.pageCount;
        })
        .catch((error) => {
          this.$$.toastr.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fieldsInit() {
      let columns = [];
      let addFields = [];
      let editFields = [];
      this.$set(this.edit, "fields", []);

      if (!this.fields) {
        return;
      }

      this.fields.map((field) => {
        if (field.table) {
          if (field.table.hidden) {
            return;
          }
        }

        let col = {
          ...field,
        };
        columns.push(col);
      });
      this.columns = columns;

      this.fields.map((field) => {
        if (field.type === "sn") {
          return;
        }
        if (field.add) {
          if (field.add.hidden) {
            return;
          }
        }

        let addField = {
          ...field,
        };
        addFields.push(addField);
      });

      this.$set(this.add, "fields", addFields);

      this.fields.map((field) => {
        if (field.type === "sn") {
          return;
        }
        if (field.edit) {
          if (field.edit.hidden) {
            return;
          }
        }

        let editField = {
          ...field,
        };
        if (field.edit) {
          if (field.edit.readonly) {
            editField.disabled = true;
            editField.readonly = true;
          }
        }
        editFields.push(editField);
      });
      this.$set(this.edit, "fields", editFields);
    },
    eLinkClick(column, item) {
      this.$emit("e-link-click", column, item);

      if (this.breadcrumbable) {
        this.breadcrumbs.push({
          value: item.sn,
          label: item.name,
        });

        let pn = "parentSN";
        if (this.breadcrumb.paramsProp) {
          pn = this.breadcrumb.paramsProp;
        }
        this.$set(this.params, pn, item.sn);
        this.reload();
      }
    },
    eBreadcrumbItemClick(item) {
      let psn = "SN-0";
      if (item) {
        psn = item.value;
      }
      let pn = "parentSN";
      if (this.breadcrumb.paramsProp) {
        pn = this.breadcrumb.paramsProp;
      }
      this.$set(this.params, pn, psn);
      this.reload();
    },
  },
  props: {
    antistop: String,
    /**
     * 自定义页标题，
     * 若设定了 label，可自动默认 ${label}
     */
    title: String,
    /**
     * 对象名称
     */
    label: String,
    /**
     * 排序字段
     */
    orderBy: Object,
    /**
     * data api 地址
     */
    url: String,
    /**
     * 字段定义
     *
     * - name   字段名称
     * - type   字段类型
     * - label  字段标题
     *
     * - maxlength  最大长度
     * - validation 验证
     * - value      默认值
     */
    fields: Array,
    /**
     * add.enable
     * add.label
     * add.fields
     */
    add: Object,
    svg: Object,
    /**
     * edit.enable
     * edit.label(row)
     * edit.success(row)
     * edit.fields
     */
    edit: Object,
    /**
     * remove.enable
     * remove.confirm(row)
     * remove.success(row)
     */
    remove: Object,
    /**
     * 是否开启多级table
     *
     * breadcrumb.enable
     * breadcrumb.paramsProp -> 面包屑点击值，改变的目标 params 的属性名，默认 parentSN
     */
    breadcrumb: Object,
    rowActions: Array,
    /**
     * 设定一个通用参数
     */
    params: [Object, Array],
    /**
     * 参数是否来自路由
     * 默认不是
     */
    paramsFromRouter: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否在 Mounted 时自动调用 reload()
     */
    mountedLoad: {
      type: Boolean,
      default: true,
    },
    bodyHeaderShow: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Object,
      default: function () {
        return {
          hidden: false,
          placeholder: "输入编码或名称搜索..",
        };
      },
    },
    selectEnable: {
      type: Boolean,
      default: false,
    },
    selectItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
